import { Outlet } from 'react-router-dom'
import { Component, type ReactNode } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import BottomNav from './BottomNav'
import SkipNav from '../ui/SkipNav'
import { useUIStore } from '../../stores/ui'
import { usePresenceHeartbeat } from '../../hooks/usePresenceHeartbeat'
import { VoIPProvider } from '../../providers/VoIPProvider'
import NotificationPoller from '../notifications/NotificationPoller'
import BrowserNotificationConsent from '../notifications/BrowserNotificationConsent'

/** Error boundary that silently swallows crashes from non-critical children. */
class SilentErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false }
  static getDerivedStateFromError() { return { hasError: true } }
  componentDidCatch(err: Error) { console.error('[NotificationError]', err) }
  render() { return this.state.hasError ? null : this.props.children }
}

export default function AppLayout() {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen)
  usePresenceHeartbeat()

  return (
    <VoIPProvider>
      <SkipNav />
      <div className="min-h-screen bg-gray-50">
        <Sidebar />
        <Header />
        <main
          id="main-content"
          className={`pt-14 transition-all duration-200 ${
            sidebarOpen ? 'md:ml-56' : 'md:ml-16'
          } ml-0 pb-16 md:pb-0`}
        >
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </main>
        <BottomNav />
      </div>
      <SilentErrorBoundary>
        <NotificationPoller />
        <BrowserNotificationConsent />
      </SilentErrorBoundary>
    </VoIPProvider>
  )
}
